/*
 * Copyright © 2018-2026, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import axios, { AxiosResponse } from "axios";

export interface MimirSummary {
  main_topic: string;
  key_points: string[];
  follow_up_required: boolean;
}

export interface MimirInitResponse {
  upload_url: string;
  transcription_id: string;
}

export interface MimirPollResponse {
  ready: boolean;
  error?: string;
  summary?: MimirSummary;
}

// Dedicated axios instance for Mimir API
// This instance does NOT have the Bearer token interceptor from axiosCommon
// Using axios.create() avoids conflicts with Basic Auth credentials
const mimirAxios = axios.create({
  baseURL: "https://tqps3uyayc.execute-api.eu-north-1.amazonaws.com",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: "Basic Z3ZhZG1pbjo3SjVESGx5VTkx",
  },
});

export default class MimirApi {
  static getStatus(): Promise<AxiosResponse> {
    return mimirAxios.get("/status");
  }

  static getPresignedUploadUrl(
    filename: string
  ): Promise<AxiosResponse<MimirInitResponse>> {
    return mimirAxios.get("/transcribe", { params: { filename } });
  }

  static uploadAudioToPresignedUrl(
    uploadUrl: string,
    file: Blob
  ): Promise<AxiosResponse> {
    return axios.put(uploadUrl, file, {
      headers: { "Content-Type": "audio/mpeg" },
    });
  }

  static pollTranscriptionResult(
    transcriptionId: string
  ): Promise<AxiosResponse<MimirPollResponse>> {
    return mimirAxios.get(`/transcribe/${transcriptionId}`);
  }
}
